<template>
  <div class="t1">
    <nav_list></nav_list>
    <div class="v3_body">

      <navv title="重要信息" en="information">
      </navv>

      <div class="cont">
        <div class="y3" v-for="(itm, n) in article.data" :key="n" @click="jump('/noteinfo?id=' + itm.id)">
          <div class="tit2">
            <div class="ico">
              <span>{{ itm.idtit[cache('lang_config')] }}</span>
            </div>

            <span class="notice">{{ itm.paths.title }}</span>

          </div>
          <div class="ttt">
            <span class="li1">{{ to_ymd(itm.created_at) }}</span>
            <span class="ico2"> <i class="el-icon-arrow-right"></i> </span>
          </div>
        </div>

        <div style=" text-align: right;padding: 10px;">
          <el-pagination background layout="prev, pager, next" :current-page="article.current_page"
            :page-size="article.per_page" :total="article.total" @current-change="change_page">
          </el-pagination>
        </div>

      </div>


    </div>





    <div class="wl2">
      <div class="titz" v-for="(itm, j) in tabs" :key="j" @click="clc_tab(itm.id)"
        v-bind:class=" { act: city_id==itm.id }">
        {{ itm[cache('lang_config')] }}
      </div>


    </div>



  </div>



  </div>
</template>


<script>

import nav_list from '../index/nav_list.vue';
export default {
  name: "index",
  data() {
    return {
      article: [],
      first_load: 1,
      article_page: 1,
      tabs: [],
      city_id: 0,
      cid: 0,
    };
  },
  methods: {
    clc_tab(city_id) {
      if (this.city_id == city_id) {
        this.city_id = 0
      } else {
        this.city_id = city_id
      }
      this.article_page = 1
      this.f5()
    },
    change_page(e) {
      this.article_page = e
      this.f5()
    },
    f5() {

      // this.article_page += inc
      this.get("/index/article_note", { page: this.article_page, n: 12, first_load: this.first_load, city_id: this.city_id }).then((e) => {
        this.first_load = 1
        this.article = e.article
        if (e.tabs) {
          this.tabs = e.tabs
        }


      });
    },


  },
  mounted() {
    if ('c' in this.$route.query) {
      this.city_id = this.$route.query.c
    }
    document.title = this.web_tit;
    this.f5()
  },
  components: {  //注册
    nav_list,
  }

};
</script>

<style scoped>
.act {
  color: #1c5098 !important;
  background-color: #f0f7ff;
  font-weight: 500;
}

.titz {
  font-size: 16px;
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
  font-weight: 400;
  color: #333333;
  background: #fff;
  border-radius: 8px;
  text-align: center;
  padding: 12px 24px;
  margin-bottom: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.titz:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.cont {
  margin: auto;
  padding: 24px;
  overflow: hidden;
  width: 62vw;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
}

.wl2 {
  flex: 0 0 20%;
  padding: 16px;
  text-align: center;
  position: fixed;
  z-index: 2;
  left: 82vw;
  top: 170px;
  flex: 0 0 18%;
  padding: 15px;
  text-align: center;
  position: fixed;
  z-index: 2;
  left: 80vw;
  top: 160px;
  background: rgba(255,255,255,0.9);
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.08);
}

.y3 {
  margin: 16px 0;
  padding: 16px;
  display: flex;
  border-radius: 8px;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  transition: all 0.3s ease;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.y3:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.y3 .tit2 {
  flex: 0 0 60%;
  display: flex;
  align-items: center;
}

.y3 .tit2 .ico {
  border-radius: 6px;
  color: #f15a25;
  width: 120px;
  height: 32px;
  line-height: 32px;
  margin-right: 16px;
  text-align: center;
  background: rgba(241, 90, 37, 0.1);
}

.y3 .tit2 .ico span {
  text-align: center;
  font-size: 16px;
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
  font-weight: 500;
}

.y3 .ico2 {
  width: 12px;
  height: 20px;
  font-size: 22px;
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
  font-weight: 400;
  color: #002b5f;
  margin-left: 20px;
}

.y3 .ttt .li1 {
  font-size: 14px;
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
  font-weight: 400;
  color: #666;
}

.y3 .tit2 .notice {
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
  font-weight: 500;
  color: #333;
  display: flex;
  font-size: 16px;
  line-height: 1.5;
}
</style>



// WEBPACK FOOTER //
// src/pages/note/actlist.vue